(function ($) {
    $(document).ready(function () {
        $('.tcu_page .tco_submit').click(function(e){
            // console.log('here tco');
            e.preventDefault;
            if($('.tcu_page form.tcu_form input[type="checkbox"]').prop("checked") == false){
                // $('.tcu_page form.tcu_form input[type="checkbox"]').prop("checked",true);
                // $('.tcu_popup').addClass('show');
                // $('body.page-template-lu-calculator-template .tcu_popup .popup_inner').focus();
                $('.tcu_agree_error').show(); 

                dataLayer.push({
                    'step':'verify-terms',
                    'funnelName':'Calculator',
                    'model':$('.tcu_page form.tcu_form select.tcu_select.tcu_brands').val(),
                    'subModel':$('.tcu_page form.tcu_form select.tcu_select.tcu_models').val(),
                    'event':'changeStep'
                });
            }
            //luEnableDisapleButton();
            
            else if(!$(this).hasClass('disabled')){
                if(luCalculatorValidFormTco($('.tcu_page form.tco_form'))){
                    dataLayer.push({
                        'Category':'TCO calculator',
                        'Action':'calculate',
                        'Label':$('.page-template-template-tco .tco_brands-slider input[name="model"]:checked').val(),
                        'event':'auto_event'
                    });
                    console.log('datalayer',dataLayer)
                    $(this).attr('disabled','disabled');
                    $('.page-template-template-tco .ajax-loader').css('visibility','visible');
                    $('.empty_fields_error').hide();
                    var formData = $('.tcu_page form.tco_form').serializeArray();
                    var url = '/wp-admin/admin-ajax.php';
                    if(window.location.href.indexOf('testonline') != -1){
                        url = 'wp-admin/admin-ajax.php';
                    }
                    $.ajax({
                        url: url, // AJAX handler
                        type: 'POST',
                        data:{
                            action:'get_lu_calculator_response',
                            formData: formData
                        },
                        
                        success: function (res) {
                            //console.log(res)
                            res = JSON.parse(res);
                            console.log(res)
                            if(res.success == 'true' ){
                             
                                $('.tcu_before_calculate').fadeOut();
                                $('.tcu_after_calculate').fadeIn();
                                $('.tcu_page .tcu_after_calculate .tcu_response .tcu_selected_distance').html(res.result.distance);
                                $('.tcu_page .tcu_after_calculate .tcu_response .tcu_selected_year').html(res.result.years);
                                $('.tcu_page .tcu_after_calculate .tcu_response .tcu_selected_model_text').html(res.result.model);
                                $('.tcu_after_calculate  .tcu_full_time_savings .tcu_total').html(res.result.full_time_total);
                                //$('.tcu_after_calculate .tcu_response_content .tcu_response_content_image img').attr('src',res.result.image_link);
                                $('.tcu_after_calculate  .tcu_monthly_savings .tcu_total').html(res.result.monthly_total);
                                $('.tcu_after_calculate  .tcu_yearly_savings .tcu_total').html(res.result.yearly_total);
                                $('.tcu_after_calculate  .tco_years').html(res.result.years);
                                $('.tcu_after_calculate  .graphs .graph h3 span.tco_years').html(res.result.years);
                                $('.tcu_after_calculate  .tco_distance').html(res.result.distance);
                                $('.tcu_after_calculate .how-did-it .model1').html(res.result.model);
                                $('.tcu_after_calculate .how-did-it .model2').html(res.result.model2);


                                $('.tco_response .benzinEnergyCost').html(res.result.benzinEnergyCost);
                                $('.tco_response .electricEnergyCost').html(res.result.electricEnergyCost);
                                if( res.result.electricTreatmentInterval.indexOf(',') != -1 ){
                                    $('.tco_response .electricTreatmentInterval').html(res.result.electricTreatmentInterval);
                                }else{
                                    $('.tco_response .electricTreatmentInterval').html(Number(res.result.electricTreatmentInterval).toLocaleString());
                                }
                                if( res.result.benzinTreatmentInterval.indexOf(',') != -1 ){
                                    $('.tco_response .benzinTreatmentInterval').html(res.result.benzinTreatmentInterval);
                                }else{
                                    $('.tco_response .benzinTreatmentInterval').html(Number(res.result.benzinTreatmentInterval).toLocaleString());

                                }
                                if( res.result.electricConsumptionData.indexOf(',') != -1 ){
                                    $('.tco_response .electricConsumptionData').html(res.result.electricConsumptionData);
                                }else{
                                    $('.tco_response .electricConsumptionData').html(Number(res.result.electricConsumptionData));

                                }
                                if( res.result.benzinConsumptionData.indexOf(',') != -1 ){
                                    $('.tco_response .benzinConsumptionData').html(res.result.benzinConsumptionData);
                                }else{
                                    $('.tco_response .benzinConsumptionData').html(Number(res.result.benzinConsumptionData).toLocaleString());

                                }
                                $('.tco_response .electricEnergyBenzinCost').html(res.result.electricEnergyBenzinCost);
                                $('.tco_response .benzinEnergyBenzinCost').html(res.result.benzinEnergyBenzinCost);
                                $('.tco_response .benzinNumTreatments').html(res.result.benzinNumTreatments);
                                $('.tco_response .electricNumTreatments').html(res.result.electricNumTreatments);
                                if( res.result.benzinPrice.indexOf(',') != -1 ){
                                    $('.tco_response .benzinPrice').html(res.result.benzinPrice);
                                }else{
                                    $('.tco_response .benzinPrice').html(Number(res.result.benzinPrice).toLocaleString());
                                }

                                if( res.result.electricPrice.indexOf(',') != -1 ){
                                    $('.tco_response .electricPrice').html(res.result.electricPrice);
                                }else{
                                    $('.tco_response .electricPrice').html(Number(res.result.electricPrice).toLocaleString());

                                }

                                if(res.result.LicensefeeCost.indexOf('-') != -1){
                                    $('.tco_response .LicensefeeCost').parent().addClass('green');
                                }
                                else{
                                    $('.tco_response .LicensefeeCost').parent().addClass('red');
                                }
                                $('.tco_response .LicensefeeCost').html(res.result.LicensefeeCost.replace('-',''));
                            
                               
                                if(res.result.depreciation.indexOf('-') != -1){
                                    $('.tco_response .depreciation').parent().addClass('green');
                                }
                                else{
                                    $('.tco_response .depreciation').parent().addClass('red');
                                }
                                $('.tco_response .depreciation').html(res.result.depreciation.replace('-',''));

                                if(res.result.energyCost.indexOf('-') != -1){
                                    $('.tco_response .energyCost').parent().addClass('green');
                                }
                                else{
                                    $('.tco_response .energyCost').parent().addClass('red');
                                }
                                $('.tco_response .energyCost').html(res.result.energyCost.replace('-',''));

                                if(res.result.maintenanceCost.indexOf('-') != -1){
                                    $('.tco_response .maintenanceCost').parent().addClass('green');
                                }
                                else{
                                    $('.tco_response .maintenanceCost').parent().addClass('red');
                                }
                                $('.tco_response .maintenanceCost').html(res.result.maintenanceCost.replace('-',''));

                                var price_diff=parseFloat(res.result.price_defference.replace(/,/g, ''));
                                price_diff=price_diff/ parseFloat($('.how-did-it .tco_years').html());
                                if(res.result.price_defference.indexOf('-') != -1){
                                    $('.tco_response .price_defference').parent().addClass('green');
                                }
                                else{
                                    $('.tco_response .price_defference').parent().addClass('red');
                                }
                                $('.tco_response .price_defference').html(price_diff.toLocaleString().replace('-','').toLocaleString());

                                if(res.result.tcf.toString().indexOf('-') != -1){
                                    $('.tco_response .tcf').parent().addClass('green');
                                }
                                else{
                                    $('.tco_response .tcf').parent().addClass('red');
                                }
                                $('.tco_response .tcf').html(res.result.tcf);

                                $('.tco_response .yearly_total').html(res.result.TCO_yearly_total.replace('-',''));
                                $('.tco_response .tcu_full_time_savings .tcu_total').html(res.result.TCO_full_time_total.replace('-',''));
                                $('.tco_response .tcu_monthly_savings .tcu_total').html(res.result.TCO_monthly_total.replace('-',''));
                                if($('.tco_response .yearly_total').html().indexOf('-') == -1){
                                    $('.tco_response .yearly_total').parent().addClass('green');
                                }
                                else{
                                    $('.tco_response .yearly_total').parent().addClass('red');
                                }
                                $('.tco-extra-buttons .tco-shop-test .tcu_button.buy').attr('href',res.result.link);
                                $('.tco-extra-buttons .tco-shop-test .tcu_button.buy').click(function(){
                                    dataLayer.push({
                                        'Category':'TCO calculator',
                                        'Action':'order online',
                                        'Label': $('.page-template-template-tco .tco_brands-slider input[name="model"]:checked').val(),
                                        'event':'auto_event'
                                    });
                                    console.log('datalayer',dataLayer)
                                })
                                $('.tco_response .tcu_yearly_savings .tcu_total').html(res.result.TCO_yearly_total.replace('-',''));

                                $('.tcu_before_calculate').hide();
                                $('body').addClass('tco_response_show');
                                $('.tcu_after_calculate').show();
                                $('.tcu_after_calculate .tcu_back_link').focus();
                                dataLayer.push({
                                    'step':'results-calc',
                                    'funnelName':'Calculator',
                                    'model':$('.tcu_page form.tcu_form select.tcu_select.tcu_brands').val(),
                                    'subModel':$('.tcu_page form.tcu_form select.tcu_select.tcu_models').val(),
                                    'event':'changeStep'
                                });
                            
                                if($('.graph.first.center .chartBox canvas').length<1){
                                    $('.graph.first.center .chartBox').append('<canvas class="tco-drive-cost" id="drive-cost" width="300" height="180" style="text-align: center"></canvas>')
                                    $('.graph.second.left .chartBox').append('<canvas class="tco-other-cost" id="other-cost" width="300" height="180" style="text-align: center"></canvas>')
                                    $('.graph.third .chartBox').append('<canvas class="tco-other-cost-2" id="other-cost-2" width="300" height="180" style="text-align: center"></canvas>')
                                }
                                else{
                                    $('.graph.first.center .chartBox canvas').remove();
                                    $('.graph.second.left .chartBox canvas').remove();
                                    $('.graph.third .chartBox canvas').remove();
                                    $('.graph.first.center .chartBox').append('<canvas class="tco-drive-cost" id="drive-cost" width="300" height="180" style="text-align: center"></canvas>')
                                    $('.graph.second.left .chartBox').append('<canvas class="tco-other-cost" id="other-cost" width="300" height="180" style="text-align: center"></canvas>')
                                    $('.graph.third .chartBox').append('<canvas class="tco-other-cost-2" id="other-cost-2" width="300" height="180" style="text-align: center"></canvas>')
                                }
                                if($('.graph.first.center .chartBox canvas').length){
                                    // Bar chart
                                    var chart1 = new Chart(jQuery(".tco-drive-cost"), {
                                        type: 'bar',
                                        data: {
                                            labels: ["חשמל","דלק"],
                                            datasets: [
                                                {
                                                    label: "עלות לק''מ באג'",
                                                    backgroundColor: [color2, color1],
                                                    barThickness: 34,
                                                    borderRadius:4.4,
                                                    data: [ parseInt($('.electricEnergyCost').html()), parseInt($('.benzinEnergyCost').html())],
                                                }
                                            ],
                                        },
                                        plugins: [ChartDataLabels],
                                        options: {
                                            plugins:{
                                                legend: {
                                                    display: false
                                                },
                                                datalabels: {
                                                    textAlign: 'center',
                                                    color: '#000000',
                                                    anchor: 'end',
                                                    align: 'top',
                                                    offset: 5
                                                }
                                            },
                                            scales: {
                                                y: {
                                                    beginAtZero: true,
                                                    
                                                },
                                                x:{
                                                    grid:{
                                                        display:false
                                                    }
                                                }
                                            },
                                            layout: {
                                                padding: {
                                                    top: 19,
                                                }
                                            }
                                        }
                                    });
                                    var chart2 = new Chart(jQuery(".tco-other-cost"), {
                                        type: 'bar',
                                        data: {
                                            labels: ["חשמל","בנזין"],
                                            datasets: [
                                                {
                                                    label: "עלות טיפולים",
                                                    backgroundColor: [color2, color1],
                                                    barThickness: 34,
                                                    borderRadius:4.4,
                                                    data: [res.result.electricTreatmentsCosts,res.result.benzinTreatmentsCosts],
                                                    datalabels: {
                                                        color: '#000000',
                                                        anchor: 'end',
                                                        align: 'top',
                                                    }
                                                }
                                            ],
                                
                                
                                        },
                                        plugins: [ChartDataLabels],
                                
                                        options: {
                                            plugins:{
                                                legend: {
                                                    display: false
                                                },
                                
                                                datalabels: {
                                                    textAlign: 'center',
                                                    color: '#000000',
                                                    anchor: 'end',
                                                    align: 'top',
                                                    offset: 5
                                                }
                                            },
                                            scales: {
                                                y: {
                                                    beginAtZero: true,
                                                    display: false
                                                },
                                                x:{
                                                    grid:{
                                                        display:false
                                                    }
                                                }
                                            },
                                            layout: {
                                                padding: {
                                                    top: 19,
                                                }
                                            }
                                        }
                                    });
                                    var electricColor=res.result.electricPollution;
                                    var benzinColor=res.result.benzinPollution;
                                    switch (electricColor) {
                                        case '1':
                                            electricColor = '#284F3e';
                                            break;
                                        case '2':
                                            electricColor = '#006543';
                                            break;
                                        case '3':
                                            electricColor = '#007A48';
                                            break;
                                        case '4':
                                            electricColor = '#008F4D';
                                            break;
                                        case '5':
                                            electricColor = '#00A651';
                                            break;
                                        case '6':
                                            electricColor = '#50B848';
                                            break;
                                        case '7':
                                            electricColor = '#A6CE39';
                                            break;
                                        case '8':
                                            electricColor = '#ebe00e';
                                            break;
                                        case '9':
                                            electricColor = '#FFCB05';
                                            break;
                                        case '10':
                                            electricColor = '#FAA61A';
                                            break;
                                        case '11':
                                            electricColor = '#F58220';
                                            break;
                                        case '12':
                                            electricColor = '#F15923';
                                            break;
                                        case '13':
                                            electricColor = '#EE1C25';
                                            break;
                                        case '14':
                                            electricColor = '#C4151B';
                                            break;
                                        case '15':
                                            electricColor = '#8C0404';
                                            break;
                                    }
                                    switch (benzinColor) {
                                        case '1':
                                            benzinColor = '#284F3e';
                                            break;
                                        case '2':
                                            benzinColor = '#006543';
                                            break;
                                        case '3':
                                            benzinColor = '#007A48';
                                            break;
                                        case '4':
                                            benzinColor = '#008F4D';
                                            break;
                                        case '5':
                                            benzinColor = '#00A651';
                                            break;
                                        case '6':
                                            benzinColor = '#50B848';
                                            break;
                                        case '7':
                                            benzinColor = '#A6CE39';
                                            break;
                                        case '8':
                                            benzinColor = '#ebe00e';
                                            break;
                                        case '9':
                                            benzinColor = '#FFCB05';
                                            break;
                                        case '10':
                                            benzinColor = '#FAA61A';
                                            break;
                                        case '11':
                                            benzinColor = '#F58220';
                                            break;
                                        case '12':
                                            benzinColor = '#F15923';
                                            break;
                                        case '13':
                                            benzinColor = '#EE1C25';
                                            break;
                                        case '14':
                                            benzinColor = '#C4151B';
                                            break;
                                        case '15':
                                            benzinColor = '#8C0404';
                                            break;
                                    }
                                    var chart3 = new Chart(jQuery(".tco-other-cost-2"), {
                                        type: 'bar',
                                        data: {
                                            labels: ["חשמל" ,"בנזין"],
                                            datasets: [
                                                {
                                                    label: "זיהום אויר",
                                                    backgroundColor: [electricColor,benzinColor],
                                                    barThickness: 34,
                                                    borderRadius:4.4,
                                                    data: [res.result.electricPollution, res.result.benzinPollution],
                                                    datalabels: {
                                                        color: '#000000',
                                                        anchor: 'end',
                                                        align: 'top',
                                                    }
                                                }
                                            ],
                                
                                
                                        },
                                        plugins: [ChartDataLabels],
                                
                                        options: {
                                            plugins:{
                                                legend: {
                                                    display: false
                                                },
                                
                                                datalabels: {
                                                    textAlign: 'center',
                                                    color: '#000000',
                                                    anchor: 'end',
                                                    align: 'top',
                                                    offset: 5
                                                }
                                            },
                                            scales: {
                                                y: {
                                                    beginAtZero: true
                                                },
                                                x:{
                                                    grid:{
                                                        display:false
                                                    }
                                                }
                                            },
                                            layout: {
                                                padding: {
                                                    top: 19,
                                                }
                                            }
                                        }
                                    });
                                }
                                //console.log(dataLayer);
                                if(window.innerWidth < 768){
                                    setTimeout(function(){
                                        $('.page-template-template-tco .graphs').on("init", function(slick) {
                                            setTimeout(function(){
                                                $('.page-template-template-tco .graphs .slick-slide').attr('tabindex','-1').click(function(e){
                                                    e.preventDefault();
                                                    //$(this).find('input').prop("checked", true);
                                                    
                                                    if(parseInt($(this).attr('data-slick-index')) > parseInt($('.page-template-template-tco .graphs .slick-active.slick-center').attr('data-slick-index'))){
                                                        $('.page-template-template-tco .graphs .slick-next').click();
                                                    }
                                                    else if(parseInt($(this).attr('data-slick-index')) < parseInt($('.page-template-template-tco .graphs .slick-active.slick-center').attr('data-slick-index'))){
                                                        $('.page-template-template-tco .graphs .slick-prev').click();
                                                    }
                                                });
                                                $('.page-template-template-tco .graphs .first.slick-slide.slick-cloned').html(
                                                    $('.page-template-template-tco .graphs .first.slick-slide[data-slick-index="0"]').html()
                                                );
                                                $('.page-template-template-tco .graphs .second.slick-slide.slick-cloned').html(
                                                    $('.page-template-template-tco .graphs .second.slick-slide[data-slick-index="1"]').html()
                                                );
                                                $('.page-template-template-tco .graphs .third.slick-slide.slick-cloned').html(
                                                    $('.page-template-template-tco .graphs .third.slick-slide[data-slick-index="2"]').html()
                                                );
                                                //console.log();
                                            },100);
                                        });
                                        $('.page-template-template-tco .graphs').slick({
                                            //infinite: false,
                                            centerMode: true,
                                            slidesToShow: 1,
                                            prevArrow: '<button type="button" class="slick-prev slick-arrow" aria-label="הקודם"></button>',
                                            nextArrow: '<button type="button" class="slick-next slick-arrow" aria-label="הבא"></button>',
                                            //arrows: false,
                                            dots:false,
                                            rtl: true,
                                        });
                                    },100);
                                }
                                $('.tcu_page .tco_submit').removeAttr('disabled');
                                $('.page-template-template-tco .ajax-loader').css('visibility','hidden');
                                $('.tco_response #close-popup').click();

                            } else{
                                $('.tcu_before_calculate .error_result').show();
                                $('.tcu_page .tco_submit').removeAttr('disabled');
                                $('.page-template-template-tco .ajax-loader').css('visibility','hidden');
                                $('.tco_response #close-popup').click();
                            }
                        }
                });  
            }
            else{
                $('.empty_fields_error').show();
            }
        }
        return false;
    });
    function luCalculatorValidFormTco(form){
        var valid = true;
        // if( form.find('select.tcu_brands').val() == '* בחר מותג'){
        //     form.find('.tcu_brands_error').show();
        //     valid = false;
        // }
        // else{
        //     form.find('.tcu_brands_error').hide();  
        // }
        // if(form.find('select.tcu_models').val() == '*בחר דגם' || form.find('select.tcu_models').val() == '* בחר דגם' || form.find('select.tcu_models').val() == null){
        //     form.find('.tcu_models_error').show();
        //     valid = false;
        // }
        // else{
        //     form.find('.tcu_models_error').hide();  
        // }
        if(!form.find('#tcu_agree').is(':checked')){
            var width = $('.tcu_agree_label .checkbox-holder').width() + $('.tcu_agree_label .checkbox-text').width() + $('.tcu_agree_label a').width();
            form.find('.tcu_agree_error').width(width + 10).show();
            valid = false;
        }
        else{
            form.find('.tcu_agree_error').hide();  
        }
        
        return valid;
    }
    $('body .graph.second.left').click(function(){
        $('.graph.second').removeClass('left');
        $('.graph.second').addClass('center');
        $('.graph.first').removeClass('center');
        $('.graph.first').addClass('right');
        $('.graph.third').removeClass('none');
        $('.graph.third').addClass('left');
    });
    $('body').on('click','.graph.first.right',function(){
        $('.graph.second').removeClass('center');
        $('.graph.second').addClass('left');
        $('.graph.first').removeClass('right');
        $('.graph.first').addClass('center');
        $('.graph.third').removeClass('left');
        $('.graph.third').addClass('none');
    });
    $('body').on('click','.graph.third.left',function(){
        $('.graph.second').removeClass('center');
        $('.graph.second').addClass('right');
        $('.graph.first').removeClass('center');
        $('.graph.first').addClass('right');
        $('.graph.third').removeClass('none');
        $('.graph.third').addClass('center');
    });
});
})(jQuery);


// WEBPACK FOOTER //
// assets/scripts/client/submitFormTco.js